import classes from './ChatWidget.module.scss'
import FeatureModal, { ModalFeedback, ModalLoading } from './FeatureModal'
import { displayValue, formatChatDate } from './chatFormatters'
import { GetSerialNumberCheckResponse } from '../../pages/MySpecial/MyOrders/models/response/getOrderListResponseModel'

export type SerialLoadStatus = 'idle' | 'loading' | 'success' | 'error'

interface Props {
  productName: string
  productCode: string
  /** Siparişin ortak seri no sorgusunun durumu; modal yalnızca sunum yapar. */
  status: SerialLoadStatus
  /** Yalnızca bu ürüne ait olacak şekilde filtrelenmiş kayıtlar. */
  serials: GetSerialNumberCheckResponse[]
  error: string | null
  onRetry: () => void
  onClose: () => void
}

/**
 * Tek ürünün seri / IMEI numaralarını gösteren modal. Sipariş kartı zaten bir modalın
 * (Kargo Takip) içinde açılabildiğinden, klavye olayları dıştaki modalın odak tuzağına
 * sızmasın diye sarmalayıcıda durdurulur.
 */
export default function OrderSerialNumberModal({
  productName,
  productCode,
  status,
  serials,
  error,
  onRetry,
  onClose,
}: Props) {
  const description = [productName, productCode].map(value => value?.trim()).filter(Boolean).join(' · ') || 'Ürün'

  return (
    <div onKeyDown={event => event.stopPropagation()}>
      <FeatureModal
        titleId='order-serial-modal-title'
        title='Seri / IMEI Numaraları'
        description={description}
        onClose={onClose}
        busy={status === 'loading'}
      >
        {(status === 'loading' || status === 'idle') && <ModalLoading label='Seri / IMEI numaraları yükleniyor…' />}

        {status === 'error' && (
          <ModalFeedback tone='error'>
            <span>{error || 'Seri numaraları şu anda alınamıyor.'}</span>
            <button type='button' className={classes.modalFeedbackAction} onClick={onRetry}>
              Tekrar dene
            </button>
          </ModalFeedback>
        )}

        {status === 'success' && serials.length === 0 && (
          <ModalFeedback tone='empty'>Bu ürün için seri numarası bulunamadı.</ModalFeedback>
        )}

        {status === 'success' && serials.length > 0 && (
          <section className={classes.modalSection} aria-labelledby='order-serial-results-title'>
            <div className={classes.modalSectionHeading}>
              <h3 id='order-serial-results-title'>Seri / IMEI numaraları</h3>
              <span>{serials.length} kayıt</span>
            </div>
            <div className={classes.modalTableWrap} tabIndex={0} aria-label='Seri numarası tablosu'>
              <table className={`${classes.modalTable} ${classes.modalTableCompact}`}>
                <thead>
                  <tr>
                    <th scope='col'>Seri / IMEI no</th>
                    <th scope='col'>Teslimat no</th>
                    <th scope='col'>Teslimat tarihi</th>
                  </tr>
                </thead>
                <tbody>
                  {serials.map((serial, index) => (
                    <tr key={`${serial.SeriNo || 'seri'}-${index}`}>
                      <td>
                        <code className={classes.orderSerialNumber}>{displayValue(serial.SeriNo)}</code>
                      </td>
                      <td>{displayValue(serial.DeliveryNumber)}</td>
                      <td>{formatChatDate(serial.DeliveryCreationDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}
      </FeatureModal>
    </div>
  )
}
